const ComponentsLookup = {
  "default-footer": "DefaultFooter5b3b095a12334be9833689172269ed9a"
}

export default ComponentsLookup;